import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ZghartaTourismApp from './App';

const AdminRoot = React.lazy(() => import('./admin/AdminRoot'));
const isAdminPath = window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isAdminPath ? (
      <React.Suspense fallback={null}>
        <AdminRoot />
      </React.Suspense>
    ) : (
      <ZghartaTourismApp />
    )}
  </React.StrictMode>
);
